import { render, staticRenderFns } from "./CustomersSegmentsFilter.vue?vue&type=template&id=27b07c92&"
import script from "./CustomersSegmentsFilter.vue?vue&type=script&lang=js&"
export * from "./CustomersSegmentsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports